import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton } from "@mui/material";
import { TilleyCard } from "components/Cards/TilleyCard";
import { DeleteIcon, EquipmentIcon } from "components/Icons/Icons";
import { formatPrice } from "utility/formatters";

export default function EquipmentCard({ equipment, onChange, handleEditClick }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const handleDeleteOnClick = async () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newEquipment = { ...equipment };
        _newEquipment.is_active = false;
        onChange?.(_newEquipment);
      },
    });
  };

  // ---

  return (
    <>
      <TilleyCard
        data-testid={`open-equipment-${equipment?.name}`}
        onClick={() => handleEditClick(equipment)}
        Avatar={EquipmentIcon}
        subtitle={equipment?.name || <>&nbsp;</>}
        title={
          [equipment?.condition, equipment?.category && `(${equipment.category})`].filter(Boolean).join(" ") ||
          "Equipment"
        }
        action={
          <>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
                return false;
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        }
        details={[
          {
            value: formatPrice(equipment?.value, 0),
            //  label: "Value",
          },
        ]}
      />
      {confirmDialogComponent}
    </>
  );
}
